import { Clipboard } from '@capacitor/clipboard';


export const copyToClipboard = async (text: string) => {
  await Clipboard.write({
    string: text,
  });
};
